<template>
	<div class="widthCen">
		<section class="fwbhtml" v-html="Info"></section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				Info: ''
			};
		},
		created() {
			if(this.$route.query.key){
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			}
			this.CardFeature();
		},
		methods: {
			CardFeature() {
				var that = this;
				that.$newapi.HtppRequest(
					'evaluation/CardFeature?id=56&index=' + 1,
					'GET', {},
					function(res) {
						console.log('获取卡的信息', res);
						if (res.code === 0) {
							var Info = res.data.Description;
							that.Info = Info;
						}
					},
					function(err) {
						console.log(err);
					});
			}
		}
	};
</script>
<style scoped></style>
